exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "scoresheet-actions {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\nscoresheet-actions .points {\r\n    margin-right: 1rem;\r\n}\r\n", ""]);

